/*
 * @Date: 2024-11-12
 * @LastEditors: liweiqi
 * @LastEditTime: 2024-11-12
 * @FilePath: \ZSI-KIMI-Worklog-FE\src\app\self-loading.service.ts
 */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingServiceT {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.loadingSubject.asObservable();

  constructor() {}

  showLoading() {
    this.loadingSubject.next(true);
  }

  hideLoading() {
    this.loadingSubject.next(false);
  }
}
